import $ from "jquery"

let click = function (index) {
  setTimeout(()=>{
    let $aList = $('#fy_tabbar ul li a');
    if($aList.length > 0) {
      $aList[index].click();

    }
  },300);
}

export default click



// WEBPACK FOOTER //
// ./src/js/clickTab.js